import { useMutation, useQueryClient } from '@tanstack/react-query'
import updateFeedbackSurvey from '../api/feedback/updateFeedbackSurvey'
import { GET_FEEDBACK_SURVEY_RESPONSE_KEY } from '../constants'

const useUpdateFeedbackSurvey = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (feedbackSurveyData: any) => {
      return await updateFeedbackSurvey(feedbackSurveyData)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_FEEDBACK_SURVEY_RESPONSE_KEY],
        })
      },
    },
  )
}

export default useUpdateFeedbackSurvey
